var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.42969C2 7.32512 2.89543 6.42969 4 6.42969H20C21.1046 6.42969 22 7.32512 22 8.42969V10.0844C22 10.9677 21.4207 11.7463 20.5747 12.0001L13.1494 14.2277C12.3996 14.4526 11.6004 14.4526 10.8506 14.2277L3.42531 12.0001C2.57934 11.7463 2 10.9677 2 10.0845V8.42969Z",
    stroke: "#ECEDEF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.5737L12 9.85938",
    stroke: "#ECEDEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.83337 11.5703L2.83337 16.9988C2.83337 19.208 4.62424 20.9988 6.83338 20.9988H17.1667C19.3758 20.9988 21.1667 19.208 21.1667 16.9988V11.5703",
    stroke: "#ECEDEF",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 6.42855V5C15.3333 3.89543 14.4379 3 13.3333 3H10.6666C9.56206 3 8.66663 3.89543 8.66663 5L8.66663 6.42855",
    stroke: "#ECEDEF",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobIcon);
export default __webpack_public_path__ + "static/media/JobIcon.43e47b13a83a97b374f1915c5c79253b.svg";
export { ForwardRef as ReactComponent };